/**
 * PALETTE CATEGORIE — STANDARD per questo tool e per i PROSSIMI tool.
 *
 * Regola (decisione utente 2026-06-10): ogni TIPO di "pezzo" della conoscenza
 * ha la SUA tinta, identica ovunque appaia (mappe, chip, legende, viste
 * future). Tinte ≠ toni: i toni della stessa tinta si leggono come STATI
 * (evidenziato sì/no), le tinte diverse come CATEGORIE.
 *
 * Il bordeaux brand (#7a1f2b) NON è una categoria: è riservato a
 * focus/selezione/autore-centrale. Quando nasce una nuova categoria di
 * pezzi, le si assegna QUI una tinta nuova (e nei token CSS).
 *
 * ⚠ Tenere in sync con le var CSS `--cat-*` in src/styles/tokens-brand.css
 * (i chip e gli stili DOM usano le var; gli SVG generati in TS usano questi hex).
 */
export const CATEGORY_COLORS = {
  /** Autore / nodo centrale — bordeaux brand */
  author: '#7a1f2b',
  /** Opera (work) — ocra */
  work: '#b87a2a',
  /** Tema generico (trattamenti: amore, natura, …) — teal */
  theme: '#1d5b6b',
  /** Movimento (Romanticismo, Modernismo, …) — prugna */
  movement: '#5d4a7e',
  /** Genere / forma (Ode, Epica, Sonetto, …) — salvia */
  genre: '#4f7350',
  /** Periodo (Romantico, Vittoriano, …) — ardesia */
  period: '#54678f',
} as const;

export type CategoryKind = keyof typeof CATEGORY_COLORS;
